import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// import Pagination from 'rc-pagination'

// @material-ui
import { Grid, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

// core
import { useGlobal } from '_core/hooks/useGlobal'
import { withLang } from '_core/hocs/withLang'
import { withCatch } from '_core/hocs/withCatch'
import { Loading } from '_core/components/Loading'
import { OwnGoodsItem } from 'basic/views/OwnGoodsItem'
import CardTitle from '_core/components/CardTitle/CardTitle'
import {
  privateDataActions,
  privateDataSelectors,
} from '_core/store/PrivateData'

// style
import { ownGoodsListStyle } from './ownGoodsListStyle'

const mapState = state => {
  return {
    ownGoods: privateDataSelectors.getOwnGoods(state)
  }
}

const mapDispatch = {
  updateOwnGoods: privateDataActions.updateOwnGoods,
}

export const RawOwnGoodsList = props => {
  const {
    classes,
    ownGoods,
    updateOwnGoods,
    getLangString: l,
  } = props

  const {
    request: { queue },
    config: { API_METHOD, ORDER_STATUS },
  } = useGlobal()

  const getOwnGoods = () => {
    queue(API_METHOD.DOCUMENT_GOODS, { statuses: [ORDER_STATUS.PAID] })
      .then(updateOwnGoods);
  }

  useEffect(getOwnGoods, [])

  const renderNothing = () => (
    <Grid item={true} xs={12}>
      <Typography
        variant="body1"
        align="center"
        className={classes.emptyMessage}
      >
        {l('r.no.paid.goods')}
      </Typography>
    </Grid>
  )

  const renderList = () => {
    if (ownGoods == null) {
      return <Loading />
    }

    const { list } = ownGoods

    if (list.length === 0) {
      return renderNothing()
    }

    return list.map((item, index) => (
      <Grid item={true} key={index} xs={12} sm={6} md={6} lg={4}>
        <OwnGoodsItem data={item} />
      </Grid>
    ))
  }

  return (
    <>
      <CardTitle icon="work" title={l('r._.owninvestments')} marginNone />

      <Grid container={true}>{renderList()}</Grid>

      {/* <Pagination showLessItems defaultCurrent={1} total={60}  className={classes.pagination} /> */}
    </>
  )
}

RawOwnGoodsList.displayName = 'RawOwnGoodsList'

RawOwnGoodsList.defaultProps = {}

RawOwnGoodsList.propTypes = {
  // `redux-connect` HOC props
  ownGoods: PropTypes.object,
  updateOwnGoods: PropTypes.func.isRequired,

  // `withStyles` HOC props
  classes: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const OwnGoodsList = withCatch(
  withLang(
    connect(
      mapState,
      mapDispatch
    )(withStyles(ownGoodsListStyle)(RawOwnGoodsList))
  )
)
